<xp-loading *ngIf="isLoadingOverlay" class="loading-overlay" [overlay]="true" [diameter]="48"></xp-loading>
<div class="otp-body" style="height: 300px">
  <div class="login-block-title mt-4 mb-4">
    <div class="mb-2 login-title">We've sent you an OTP to your email.</div>
    <div class="login-subtitle">
      Please enter the OTP below to verify your account. If you didn't receive
      the email, check your spam folder or request a new OTP.
    </div>
  </div>

  <xp-otp-input [invalid]="otpInputError"
                [disabled]="secondsOtpBlock > 0"
                [(value)]="otpValue"
                (completed)="checkOneTimePassword(ProcessId, $event)"></xp-otp-input>
  <xp-message *ngIf="wrongOtpAttemptCount !== 3 && otpError" class="otp-error mg-auto" severity="error" [plain]="true">{{ otpError }}</xp-message>
  <xp-message
    *ngIf="wrongOtpAttemptCount === 3"
    class="lm-active-order-details-canceled-block mg-auto text-center"
    severity="error"
    [plain]="true"
  >
    You have entered the OTP incorrectly 3 times. For your security, your
    session has been temporarily locked. Please try again after
    {{ secondsOtpBlock }} seconds.
  </xp-message>

  <div class="flex mt-1 w-100">
    <button mat-stroked-button type="button" class="operator-btn resend-otp-btn w-100"
            [disabled]="secondsToResend > 0" (click)="resendOTP()">
      Resend ({{ secondsToResend }} secs)
    </button>
  </div>
</div>
